import { GetFamilyAlbumListAPICall } from 'reactApp/api/family/GetFamilyAlbumListAPICall';
import { GetFamilyFolderListCall } from 'reactApp/api/family/GetFamilyFolderListCall';
import {
    changeFamilyContentCategory,
    familyAlbumsLoadSuccess,
    familyContentLoadRequest,
    familyContentLoadStart,
    familyFoldersLoadSuccess,
} from 'reactApp/modules/familyContent/familyContent.module';
import { FamilyContentCategoryType } from 'reactApp/modules/familyContent/familyContent.types';
import { getFeedCategory } from 'reactApp/modules/feed/feed.selectors';
import { ESortOder } from 'reactApp/modules/sort/sort.types';
import { put, select, takeEvery } from 'redux-saga/effects';

const getAlbumsListCall = () => new GetFamilyAlbumListAPICall().makeRequest({ order: ESortOder.desc });
const getFolderListCall = () => new GetFamilyFolderListCall().makeRequest({ order: ESortOder.desc });

function* fetchFamilyContent(category: FamilyContentCategoryType) {
    const currentCategory: FamilyContentCategoryType = !category ? yield select(getFeedCategory) : category;

    try {
        let data;

        switch (currentCategory) {
            case FamilyContentCategoryType.folders:
                data = (yield getFolderListCall()).data;
                break;
            case FamilyContentCategoryType.albums:
                data = (yield getAlbumsListCall()).data;
                break;
        }

        return { category: currentCategory, data };
    } catch (error) {
        return { category: currentCategory, data: [] };
    }
}

function* loadFamilyContentByRequest(action) {
    const category = action?.payload?.category || FamilyContentCategoryType.folders;
    yield put(familyContentLoadStart({ category }));

    const res = yield fetchFamilyContent(category);

    if (category === FamilyContentCategoryType.folders) {
        yield put(familyFoldersLoadSuccess(res));
    } else if (category === FamilyContentCategoryType.albums) {
        yield put(familyAlbumsLoadSuccess(res));
    }
}

function* loadFamilyContentCategory(action) {
    const category = action.payload.category;
    yield put(familyContentLoadStart({ category }));
}

export function* watchFamilyContent() {
    yield takeEvery(familyContentLoadRequest.toString(), loadFamilyContentByRequest);
    yield takeEvery(changeFamilyContentCategory.toString(), loadFamilyContentCategory);
}
